"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBorderRadiusTokens = void 0;
var fs_1 = __importDefault(require("fs"));
var path_1 = __importDefault(require("path"));
var generateBorderRadiusTokens = function (themesFolder) {
    if (!fs_1.default.existsSync(themesFolder)) {
        return {};
    }
    return fs_1.default
        .readdirSync(themesFolder, { withFileTypes: true })
        .filter(function (item) { return item.isFile() && path_1.default.extname(path_1.default.join(themesFolder, item.name)) === '.json'; })
        .reduce(function (colorSchemas, item) {
        var _a;
        var fileContent = fs_1.default.readFileSync(path_1.default.join(themesFolder, item.name), 'utf-8');
        var borderRadiusTokens = JSON.parse(fileContent).borderRadius;
        var themeName = path_1.default.parse(item.name).name;
        return __assign(__assign({}, colorSchemas), (_a = {}, _a[themeName] = __assign({}, borderRadiusTokens), _a));
    }, {});
};
exports.generateBorderRadiusTokens = generateBorderRadiusTokens;
//# sourceMappingURL=generateBorderRadiusTokens.js.map